import React from "react";

const TileFooter = ({ children }) => {
    return <div className="Tile-foot">{children}</div>;
};
export default TileFooter;
